import { z } from "zod";
import { NodeSchema, EdgeSchema } from "./automation-nodes.schema";

export const AutomationSchema = z.object({
  name: z.string().optional(),
  nodes: z.array(NodeSchema),
  edges: z.array(EdgeSchema),
  is_active: z.boolean().optional(),
  meta: z.any().optional(),
});

export type Automation = z.infer<typeof AutomationSchema>;
